import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Link } from '@material-ui/core';

const scheduleLinkStyles = makeStyles({
  root: {
    fontSize: '16px',
    fontWeight: 'normal',
    textTransform: 'none',
    lineHeight: '120%',
    color: '#424242',
    '&:hover': {
      color: '#3A9E12',
      textDecoration: 'none',
    },
  },
});

export default function ScheduleLink(props) {
  const { children, onClick, href } = props;
  const classes = scheduleLinkStyles();

  return (
    <Link
      onClick={onClick}
      href={href}
      underline="always"
      className={classes.root}
    >
      {children}
    </Link>
  );
}

ScheduleLink.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  href: PropTypes.string,
};

ScheduleLink.defaultProps = {
  href: '',
};
